/* PhoneMatter Aura UI: behaviour shared by list pages (collection, search).
   Adds the dimmed backdrop for the filter sheet, the glass dock on phones, and keeps the sort sheet above the page. */
(function () {
  'use strict';
  var sheetQ = window.matchMedia('(max-width:1024px)');

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var fb = document.querySelector('.filterbar');
    var filterBtn = document.querySelector('.btn-filter');
    var sortBtn = document.querySelector('.js-pcp-sort-btn');
    var pop = document.getElementById('pcp-sort-popover');
    if (!document.getElementById('pcp-filter-bar') && !fb) return;

    var scrim = document.createElement('div');
    scrim.className = 'pmu-scrim';
    document.body.appendChild(scrim);

    function sync() {
      var on = !!(fb && fb.classList.contains('active') && sheetQ.matches);
      var sortOn = !!(pop && pop.classList.contains('open') && sheetQ.matches);
      scrim.classList.toggle('on', on || sortOn);
      document.body.classList.toggle('pmu-sheet', on || sortOn);
    }

    if (fb && window.MutationObserver) new MutationObserver(sync).observe(fb, { attributes: true, attributeFilter: ['class'] });
    if (pop && window.MutationObserver) new MutationObserver(sync).observe(pop, { attributes: true, attributeFilter: ['class'] });

    scrim.addEventListener('click', function () {
      if (fb) fb.classList.remove('active');
      if (pop) pop.classList.remove('open');
      if (sortBtn) sortBtn.classList.remove('active');
      sync();
    });

    /* filter groups are ordered the same everywhere: phone, style, colour, price, availability, the rest */
    var rank = { phone: 1, style: 2, colour: 3, price: 4, avail: 5 };
    if (fb) {
      [].forEach.call(fb.querySelectorAll('#CollectionFiltersForm > div'), function (g) {
        var t = g.querySelector('.sb-toggle');
        if (!t) return;
        var n = t.textContent.toLowerCase(), k = 'other';
        if (/device|model|compat/.test(n)) k = 'phone';
        else if (/more filters|style|type/.test(n)) k = 'style';
        else if (/colou?r/.test(n)) k = 'colour';
        else if (/price/.test(n)) k = 'price';
        else if (/availab/.test(n)) k = 'avail';
        g.setAttribute('data-pmg', k);
        g.style.order = rank[k] || 6;
        /* on phones the sheet opens short: phone and style open, the rest one tap away */
        if (sheetQ.matches && k !== 'phone' && k !== 'style' && !g.querySelector('input:checked')) g.classList.add('sb-section-collapsed');
      });
    }


    /* "More filters" tags are sorted into clear groups, with the same pill look everywhere */
    try { (function () {
      var g = fb && fb.querySelector('[data-pmg=style]');
      var ul = g && g.querySelector('ul.flOpt');
      if (!ul || ul.getAttribute('data-pmu')) return;
      ul.setAttribute('data-pmu', '1');
      var MAP = [
        ['Material', /leather|clear|silicon|metal|plastic|glass|fabric|wood|carbon|chrome/],
        ['Features', /magsafe|kickstand|stand|lanyard|strap|wallet|ring|holder|card|charm|chain/],
        ['Protection', /slim|rugged|shock|bumper|armor|heavy|thin/]
      ];
      var buckets = { Material: [], Features: [], Protection: [], Look: [] };
      [].slice.call(ul.querySelectorAll('label.fl-checkbox')).map(function (l) { var li = document.createElement('li'); li.appendChild(l); return li; }).forEach(function (li) {
        var t = li.textContent.trim().toLowerCase(), k = 'Look';
        for (var i = 0; i < MAP.length; i++) if (MAP[i][1].test(t)) { k = MAP[i][0]; break; }
        buckets[k].push(li);
      });
      var last = ul;
      ['Material', 'Features', 'Protection', 'Look'].forEach(function (k) {
        if (!buckets[k].length) return;
        buckets[k].sort(function (a, b) { return a.textContent.trim().localeCompare(b.textContent.trim()); });
        var w = document.createElement('div');
        w.className = 'pmu-cl';
        w.innerHTML = '<div class="pmu-cl-t">' + k + '</div>';
        var u = document.createElement('ul');
        u.className = 'widget-content flOpt';
        buckets[k].forEach(function (li) { u.appendChild(li); });
        w.appendChild(u);
        if (buckets[k].length > 8) {
          u.classList.add('pmu-cap');
          var more = document.createElement('button');
          more.type = 'button'; more.className = 'pmu-more';
          more.textContent = 'Show ' + (buckets[k].length - 8) + ' more';
          more.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); u.classList.remove('pmu-cap'); more.remove(); });
          w.appendChild(more);
        }
        last.parentNode.insertBefore(w, last.nextSibling);
        last = w;
      });
      ul.style.display = 'none';
    })(); } catch (e1) { e1 = 0; }

    /* price: quick ranges set both ends at once */
    try { (function () {
      var gte = document.getElementById('Filter-Price-GTE'), lte = document.getElementById('Filter-Price-LTE');
      var host = fb && fb.querySelector('.flPrice .sb-section-body');
      if (!gte || !lte || !host || host.querySelector('.pmu-qr')) return;
      var max = Math.round(parseFloat(lte.getAttribute('max') || lte.value || '0'));
      if (!(max > 3)) return;
      var a = Math.round(max / 3), b = Math.round(max * 2 / 3);
      var q = document.createElement('div');
      q.className = 'pmu-qr';
      q.innerHTML = '<div class="pmu-cl-t">Quick ranges</div><div class="pmu-qrp">' +
        '<button type="button" data-lo="0" data-hi="' + a + '">Under $' + a + '</button>' +
        '<button type="button" data-lo="' + a + '" data-hi="' + b + '">$' + a + ' to $' + b + '</button>' +
        '<button type="button" data-lo="' + b + '" data-hi="' + max + '">Over $' + b + '</button></div>';
      host.appendChild(q);
      q.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        e.preventDefault(); e.stopPropagation();
        gte.value = btn.getAttribute('data-lo'); lte.value = btn.getAttribute('data-hi');
        [gte, lte].forEach(function (el) { ['input', 'change'].forEach(function (n) { el.dispatchEvent(new Event(n, { bubbles: true })); }); });
        [].forEach.call(q.querySelectorAll('button'), function (x) { x.classList.toggle('on', x === btn); });
      });
    })(); } catch (e2) { e2 = 0; }

    /* phone and tablet: one filter group at a time, behind tabs, with a count on each */
    if (fb && sheetQ.matches) {
      var form = fb.querySelector('#CollectionFiltersForm');
      var card = form && form.closest('.sb-card');
      if (card) {
        var groups = [].slice.call(form.querySelectorAll(':scope > div[data-pmg]'));
        groups.forEach(function (g) {
          var k = g.getAttribute('data-pmg');
          g.setAttribute('data-pmt', (k === 'avail' || k === 'other') ? 'more' : k);
          g.classList.remove('sb-section-collapsed');
        });
        var NAMES = { phone: 'Phone', style: 'Style', colour: 'Colour', price: 'Price', more: 'More' };
        var keys = ['phone', 'style', 'colour', 'price', 'more'].filter(function (k) { return form.querySelector('[data-pmt=' + k + ']'); });
        var bar = document.createElement('div');
        bar.className = 'pmu-tabs';
        bar.setAttribute('role', 'tablist');
        keys.forEach(function (k) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('data-t', k); b.setAttribute('role', 'tab');
          b.innerHTML = NAMES[k] + '<b></b>';
          bar.appendChild(b);
        });
        card.parentNode.insertBefore(bar, card);
        fb.classList.add('pmu-tabs-on');
        var counts = function () {
          keys.forEach(function (k) {
            var n = form.querySelectorAll('[data-pmt=' + k + '] input:checked').length;
            var b = bar.querySelector('[data-t=' + k + '] b');
            if (b) b.textContent = n ? n : '';
          });
        };
        var setTab = function (k) {
          fb.setAttribute('data-tab', k);
          [].forEach.call(bar.children, function (x) { x.classList.toggle('on', x.getAttribute('data-t') === k); x.setAttribute('aria-selected', x.getAttribute('data-t') === k); });
        };
        bar.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) { e.stopPropagation(); setTab(b.getAttribute('data-t')); } });
        form.addEventListener('change', counts);
        counts();
        setTab(keys[0]);
      }
    }

    /* a sticky "Show cases" button closes the filter sheet (filters apply as they are picked) */
    if (fb) {
      var ap = document.createElement('div');
      ap.className = 'pmu-apply';
      ap.innerHTML = '<button type="button">Show results</button>';
      fb.appendChild(ap);
      ap.firstChild.addEventListener('click', function (e) { e.stopPropagation(); fb.classList.remove('active'); sync(); });
      var tc = document.getElementById('sbTotalCount');
      if (tc && window.MutationObserver) {
        var setLbl = function () { var n = (tc.textContent.match(/\d+/) || [''])[0]; ap.firstChild.textContent = n ? 'Show ' + n + ' results' : 'Show results'; };
        setLbl(); new MutationObserver(setLbl).observe(tc, { childList: true, characterData: true, subtree: true });
      }
    }

    /* the sort sheet is lifted out of the glass bar so it can sit fixed above the page on phones */
    if (pop && sheetQ.matches) document.body.appendChild(pop);

    /* glass dock on phones and tablets: Filters, Sort */
    if (filterBtn || sortBtn) {
      var dock = document.createElement('div');
      dock.className = 'pmu-dock';
      var count = filterBtn ? filterBtn.querySelector('.pcp-badge') : null;
      dock.innerHTML = (filterBtn ? '<button type="button" class="main" data-d="f">Filters' + (count ? ' <b>' + count.textContent.trim() + '</b>' : '') + '</button>' : '') +
                       (sortBtn ? '<button type="button" data-d="s">Sort</button>' : '');
      document.body.appendChild(dock);
      dock.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        e.stopPropagation();
        try { if (navigator.vibrate) navigator.vibrate(10); } catch (x) { x = 0; }
        if (b.getAttribute('data-d') === 'f' && filterBtn) filterBtn.click();
        if (b.getAttribute('data-d') === 's' && sortBtn) sortBtn.click();
      });
    }
  });
})();
